export interface ArchiveTarget {
  documentId: string;
  commentId?: string;
}

export const ARCHIVE_TARGET_EVENT = 'openArchiveTarget';

export function buildArchiveTargetPath(target: ArchiveTarget): string {
  const params = new URLSearchParams({
    tab: 'archive',
    documentId: target.documentId,
  });

  if (target.commentId) {
    params.set('commentId', target.commentId);
  }

  return `/?${params.toString()}`;
}

export function readArchiveTargetFromUrl(): ArchiveTarget | null {
  const url = new URL(window.location.href);
  const tab = url.searchParams.get('tab');
  const documentId = url.searchParams.get('documentId');

  if (!documentId) {
    return null;
  }

  if (tab && tab !== 'archive') {
    return null;
  }

  return {
    documentId,
    commentId: url.searchParams.get('commentId') || undefined,
  };
}

export function writeArchiveTargetToUrl(target: ArchiveTarget, historyMode: 'push' | 'replace' = 'push'): string {
  const url = new URL(window.location.href);
  url.searchParams.set('tab', 'archive');
  url.searchParams.set('documentId', target.documentId);

  if (target.commentId) {
    url.searchParams.set('commentId', target.commentId);
  } else {
    url.searchParams.delete('commentId');
  }

  const nextUrl = `${url.pathname}${url.search}${url.hash}`;

  if (historyMode === 'replace') {
    window.history.replaceState({}, '', nextUrl);
  } else {
    window.history.pushState({}, '', nextUrl);
  }

  return nextUrl;
}

export function clearArchiveTargetFromUrl(): void {
  const url = new URL(window.location.href);
  url.searchParams.delete('documentId');
  url.searchParams.delete('commentId');

  if (url.searchParams.get('tab') === 'archive') {
    url.searchParams.delete('tab');
  }

  window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
}

export function openArchiveTarget(target: ArchiveTarget): string {
  const nextUrl = writeArchiveTargetToUrl(target, 'push');
  window.dispatchEvent(new CustomEvent<ArchiveTarget>(ARCHIVE_TARGET_EVENT, { detail: target }));
  return nextUrl;
}